import { render, staticRenderFns } from "./ProductSubcategoryComponent.vue?vue&type=template&id=59a2cecb&scoped=true"
import script from "./ProductSubcategoryComponent.vue?vue&type=script&lang=js"
export * from "./ProductSubcategoryComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductSubcategoryComponent.vue?vue&type=style&index=0&id=59a2cecb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a2cecb",
  null
  
)

export default component.exports